module.exports = __webpack_public_path__ + "media/images/abstract-bg-3-9c9bede32e8fd0bc1eb583938661f2dd.svg";